$(document).ready(function() {

    if($('.header__right__mobile').length){
      $('.header__icon-touch--search').clone().appendTo($('.header__right__mobile'));
    }

    $('.icon-open-menu').click(function(e){
      if(!$('#shopify-section-header > header.is-open').length){
        $('#shopify-section-header > header').addClass("is-open");
        if(!$('#shopify-section-header > header').hasClass('is-sticky')){
          $('#shopify-section-header > header').addClass("is-sticky");
        }
      }
       $('section.drawer-menu').addClass('active visible');
    });

    $('.icon-close-menu').click(function(){
        if($('#shopify-section-header > header.is-open').length > 0) {
            $('#shopify-section-header > header').removeClass("is-open");
        }
        $('section.drawer-menu').removeClass('active visible');
        $('body').css("overflow-y", 'auto');
        $('body').css("overflow-x", 'hidden');
        $('body').css("padding-right", '0');
    if(!$('#shopify-section-header > header').hasClass('is-sticky')){
        $('#shopify-section-header > header').addClass("is-sticky");
    }
    });

    //Handle all dropdown blocks 
    $('.product_info_header').click(function(){
        $(this).parent().toggleClass("bloc_closed bloc_open");
        $(this).next().slideToggle(300);
        $(this).parents('form.product-form').find(".product-delivery-info").toggle();
    });

    //Handle all dropdown blocks - CMS global version
    $('.cms_header').click(function(){
        $(this).parent().toggleClass("bloc_closed bloc_open");
        $(this).next().slideToggle(300);
    });

    //Handle shipping and return CMS dropdown blocks
    $('.section_shipping').click(function () {
        $('.Shipping__SectionWrapper').hide();
        $('.open').show();
        $('.close').hide();
        //On active
        $(this).children('.open').hide();
        $(this).children('.close').show();
        $(this).next().slideToggle(300);
    });

    $('.Shipping__Onglet').click(function () {
      $('.Shipping__ExplicationWrapper').hide();
      $('.Shipping__Onglet').removeClass('ActiveShipping');
      $(this).addClass('ActiveShipping');
      //Si c'est visible
      $('.open_sub').show();
      $('.close_sub').hide();
      $(this).next().hide();
      $(this).next().next().show();
      $(this).next().next().next().slideToggle(300);
    });

    /* Template index handler */
    if($('.template-index').length && $('.collection-custom-slider').length){
        //activate slider once to setup the first background
        rotateSlides();
        $('.link-list_arrow_left, .link-list_ctrl.link-list_ctrl_left').click(function(e){
            e.stopPropagation();
            rotateSlides("prev");
        });
        $('.link-list_arrow_right, .link-list_ctrl.link-list_ctrl_right').click(function(e){
            e.stopPropagation();
            rotateSlides("next");
        });

         // Swipe / Drag support
        const slider = $('.collection-custom-slider');
        let startX = 0;
        let endX = 0;
        let isDragging = false;

        // --- Touch events (mobile) ---
        slider.on('touchstart', function(e) {
            startX = e.originalEvent.touches[0].clientX;
        });

        slider.on('touchmove', function(e) {
            endX = e.originalEvent.touches[0].clientX;
        });

        slider.on('touchend', function() {
            handleSwipe(endX - startX);
        });

        // --- Mouse events (desktop drag) ---
        slider.on('mousedown', function(e) {
            isDragging = true;
            startX = e.clientX;
        });

        slider.on('mousemove', function(e) {
            if (isDragging) {
            endX = e.clientX;
            }
        });

        slider.on('mouseup', function() {
            if (isDragging) {
            handleSwipe(endX - startX);
            isDragging = false;
            }
        });

        slider.on('mouseleave', function() {
            // cancel drag if mouse leaves the slider
            isDragging = false;
        });

        // --- Helper function ---
        function handleSwipe(distance) {
            const threshold = 50; // Minimum px for swipe
            if (Math.abs(distance) > threshold) {
            if (distance > 0) {
                rotateSlides("prev"); // swipe right
            } else {
                rotateSlides("next"); // swipe left
            }
            }
        }
    }

    if($('.btn-mute').length){
        $('.btn-mute').click(function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            var $video = $(this).prev();
            console.log($video);
            if($video.prop("muted")) {
            $video.prop("muted", !1);
            $(this).find(".volume-low").hide();
            $(this).find(".volume-high").show();
            }
            else {            
            $video.prop("muted", !0);
            $(this).find(".volume-high").hide();
            $(this).find(".volume-low").show();
            }
        });
    }

    if ($(window).width() > 700) { // Only run on desktop
  if ($('.template-collection').length) {

    // //Clean the grid of it's floaty text
    // $(".collection__grid").contents().filter(function(){
    //     return (this.nodeType == 3);
    // }).remove();

    //Update the product grid with the good format
    if ($('.collection__grid .grid__item:first').length > 0) {
      //Restructurate Collection page
      var bumper = $('.collection__grid .grid__item:nth-child(8n+4), .collection__grid .grid__item:nth-child(4)');
      var targetToMove = $('.collection__grid .grid__item:nth-child(8n+5), .collection__grid .grid__item:nth-child(8n+6), .collection__grid .grid__item:nth-child(8n+7), .collection__grid .grid__item:nth-child(8n), .collection__grid .grid__item:nth-child(5), .collection__grid .grid__item:nth-child(6), .collection__grid .grid__item:nth-child(7)');
      var newDiv = '<div class="grid__item--2 custom-grid-collection-column"></div>';
      bumper.after(newDiv);
      targetToMove.addClass('custom-grid-collection-item');
      targetToMove.each(function(){
        var destination = $(this).prevAll('.custom-grid-collection-column:first');
        $(this).appendTo(destination);
      });

      //Special handling for asymetric images
      var offsetThird = $('.collection__grid .grid__item .product-item:first').height();
      var targetThird = $('.collection__grid > .grid__item:nth-child(5n+3) .product-item__media .product-item__image, .collection__grid > .grid__item:nth-child(3) .product-item__media .product-item__image');
      targetThird.css("padding-top", offsetThird);
      
      var offsetFourth = $('.collection__grid > .grid__item:nth-child(5n+4):first').height();
      var targetFourth = $('.collection__grid > .grid__item:nth-child(5n+4) .product-item__media .product-item__image, .collection__grid > .grid__item:nth-child(4) .product-item__media .product-item__image');
      targetFourth.css("padding-top", offsetFourth);

      targetThird.toggleClass("product-item__image--two");
      targetFourth.toggleClass("product-item__image--two");
    }

    //process the sub_category_list on alternate collection template
    if ($('.custom_header_span_collection_name').length) {
      var imgWidth = 229,
          imgHeight = 300,
          spanHeight = $('.custom_header_span_collection_name:first').outerHeight(),
          topValue = Math.ceil(-1 * ((imgHeight / 2) - (spanHeight / 2)));

      $('.custom_header_span_collection_image:first').hide();
      $('.custom_header_span_collection_image').css("top", topValue);

      $('.custom_header_span_collection_name').mouseenter(function() {
        leftValue = Math.ceil(-1 * ((imgWidth / 2) - ($(this).outerWidth() / 2)));
        $(this).css("z-index", 12);
        $(this).prev().find("img").css("left", leftValue);
        $(this).prev().find("img").show();
      });
      $('.custom_header_span_collection_name').mouseleave(function() {
        $(this).css("z-index", 10);
        $(this).prev().find("img").hide();
      });
    }
  }
}


    if($('.template-product').length){

        //Handle the font mechanics from stock availability on variants
        if($('.product_variant_form_hidden').length < 1){
            var baseValue = $('#variant-selector option:first').data("variant");
            availability = getAvailability(baseValue);
            updateProductFormVariant(availability, true);
            updateTextRecap("no variant");
        } else {
            $('.product_variant_form_hidden').each(function(){
                var $this = $(this);
                var newAvailable = false;
                var optionPosition = $this.data("position");

                //Filter the research on the size attribute only
                var sizeAttr = "taille bague Taille bague taille Bague Taille Bagues TAILLE BAGUE TAILLE BAGUES Sélectionner une taille sélectionner une taille ring size Ring size ring Size Ring SIZE RING SIZE Waistband waistband WAISTBAND Select a size select a size";
                var isSizeRelated = sizeAttr.includes($this.data("attribute")) ? true : false; //detect the usage of size attribute
                var isQtyRelated = $this.parents().parents().hasClass("pf-container-variant-select-quantite") ? true : false; //detect the usage of Qty attribute

                //Handle change event
                $this.change(function(e){
                    //Check if new selected variant is available
                    var val = $this.val();
                    var dataAvailability = getAvailability(val, isSizeRelated, isQtyRelated);

                    //Update template with new data
                    updateProductFormVariant(dataAvailability, true);
                    updateTextRecap(val, isSizeRelated, isQtyRelated);

                    //In case of a Qty variant, we want the unit to be sold 2 times instead of 1 Pair
                    if(isQtyRelated) {
                        processQty(val);
                    }
                });

                //Check if current variant is available (on page loading)
                var baseValue = $this.val();
                var baseDataAvailability = getAvailability(baseValue, isSizeRelated, isQtyRelated);

                //In case of a Qty variant, we want the unit to be sold 2 times instead of 1 Pair
                if(isQtyRelated) {
                    //Correct the wrong page redirection when selecting "Paire" variant from boucles uniques 
                    if(baseValue == "Paire") {
                        //Correct the add to cart qty
                        $('input[value="'+baseValue+'"]').parent().next().addClass("selected_value");
                        $('.product_variant_selection').text(baseValue);

                        //Correct the price displayed
                        var trueUnitPrice = $('.product_unit_price').data("price-pair");
                        var truePairPrice = $('.product_pair_price').data("price-pair"); 
                        $('.product_unit_price').text(trueUnitPrice);
                        $('.product_pair_price').text(truePairPrice);
                    }
                    //Display the correct price and setup the good qty when "Pair" is selected
                    processQty(baseValue);
                }

                //Populate the rest of the product page template with the good data
                updateProductFormVariant(baseDataAvailability, true);
                updateTextRecap(baseValue, isSizeRelated, isQtyRelated);

                //Populate variant list with good data
                if($('input[name="option_'+optionPosition+'"]').length) {

                    //Attach availability for each variant on the list
                    $('input[name="option_'+optionPosition+'"]').each(function(e){
                        var dataVariantAvailability = getAvailability( $(this).prop("value") , isSizeRelated, isQtyRelated);

                        if( dataVariantAvailability == "available" ){
                            // it's available now
                            $(this).parent().next().find('.variant_availability_value-available').show();
                            $(this).parent().next().find('.variant_availability_value-unavailable').hide();
                            $(this).parent().next().find('.variant_availability_value-available-with-delay').hide();

                            //Override default value if the default is not available
                            if(baseDataAvailability != "available" && !newAvailable) {
                                newDefaultValue = $(this).prop("value");
                                $(this).prop("checked", true);
                                $(this).parent().next().addClass("selected_value");
                                $('.product_variant_form_hidden').val(newDefaultValue).change();
                                $('.product_variant_selection').text(newDefaultValue);
                                newAvailable = true;
                            }
                        } else if(dataVariantAvailability == "delayed"){
                            // it's available with delay
                            $(this).parent().next().find('.variant_availability_value-available').hide();
                            $(this).parent().next().find('.variant_availability_value-unavailable').hide();
                            $(this).parent().next().find('.variant_availability_value-available-with-delay').show();
                        } else {
                            // it's unavailable
                            $(this).parent().next().find('.variant_availability_value-available').hide();
                            $(this).parent().next().find('.variant_availability_value-unavailable').show();
                            $(this).parent().next().find('.variant_availability_value-available-with-delay').hide();
                        }
                    });

                    //assign the new variant to the hidden selector (and trigger the change event)
                    $('input[name="option_'+optionPosition+'"]').change(function(e){
                        $(this).parent().parent().find("li.selected_value").removeClass("selected_value");
                        $(this).parent().next().addClass("selected_value");
                        $('.product_variant_selection').text($(this).val());
                        $this.val($(this).val()).change();


                        console.log("variant changed");
                        variantID = getVariantID();
                        locationStockAvailable = getVariantLocationDetails(variantID);
                        setupVariantLocationDetails(locationStockAvailable);

                    });

                    //Select the default value
                    if($('.product_info_text li.selected_value').length < 1) {
                        $('input[value="'+baseValue+'"]').parent().next().addClass("selected_value");
                        $('.product_variant_selection').text(baseValue);
                    }
                }
            });
        }
        
        //Handle the reminder bloc add_to_cart button
        if($('.recap_add_to_cart').length){

            //Process the fixed position
            var bumper = $('.recap_add_to_cart').offset().top - $('#shopify-section-header').outerHeight();
            var isScriptSetup = false;
            $(window).scroll(function () {
                if ($(window).scrollTop() >= bumper) {
                    $('.recap_add_to_cart').addClass("recap_add_to_cart_fixed");
                } else {
                    $('.recap_add_to_cart').removeClass("recap_add_to_cart_fixed");
                }
            });

            //Handle the functionnality with
            $('body').on({
                'touchmove': function(e) { 
                    //bumper need to be at last at 98x ~ 1xxx
                    if(!isScriptSetup || bumper < 950){
                        bumper = $('.recap_add_to_cart').offset().top - $('#shopify-section-header').outerHeight();
                        isScriptSetup = true;
                    }
                    if ($(this).scrollTop() >= bumper) {
                        $('.recap_add_to_cart').addClass("recap_add_to_cart_fixed");
                    } else {
                        $('.recap_add_to_cart').removeClass("recap_add_to_cart_fixed");
                    }
                }
            });

            $('.recap_add_to_cart_button button').click(function(){
                $('.product-form .product-form__cart-submit').click();
            });
        }

        //Handle the zoom-in icon on slider
        if($('.zoom-icon-wrapper').length){
            var dataOpen = $('.media__image').data("open"); // store original data-open
            $('.zoom-icon-wrapper').click(function(){
                var currentOpenData = $.map($('.carousel__slide.is-selected .carousel__image')[0].classList, function(cls, i) {
                    if (cls.indexOf('image--') === 0) {
                        return cls.replace('image--', '');
                    }
                });

                //Use the new data-open and immediately reset it
                $('.media__image').attr("data-open", currentOpenData[0]);
                $('.media__image img').click();
                $('.media__image').attr("data-open", dataOpen);
            });
        }

        var $carousel = $('.carousel.product-carousel');
        $carousel.on( 'staticClick.flickity', function( e, pointer, cellElement, cellIndex ) {
          if ($(cellElement).find('.image').length) {
            let $img = $(cellElement).find('.image');
            let imgID = $img[0].classList[1].split("--").pop();
            let $elementToTrigger = $('.product__media-container a.media__image[data-open="'+ imgID +'"]');
            $elementToTrigger[0].click();
          }
        });

        // $('.product__color-swatch').each(function(){
        //     var newUrl = $(this).prop("href");
        //     $(this).click(function(){
        //         window.location.href = newUrl;
        //     });
        // });

        //Recadre les images des bracelets
        if(window.location.pathname.includes("bracelet")) {
            $('body.template-product .product__media-container').css('margin-top', 0);
        }

        //Enleve l'event clique sur la dispo en boutique
        if($('.infos_dispo_boutique').length){
            $('.infos_dispo_boutique').click(function(e){
                e.preventDefault();
                $(this).unbind();
            });
        }

        /*
        //Custom add to cart script
        $('.product-form__cart-submit').click(function(){
              //Step 1 get all carts items
              var cart_items = {};
              $.getJSON('/cart.js', function(cart) {
                  cart_items = cart.items;
              });
              console.log(cart_items);

              //Step 2 assign new quantities to cart items and update it
            var cartUpdates =  { "40015483273374": 1 };
            var params = {
                type: 'POST',
                url: '/cart/update.js',
                data: { updates: cartUpdates },
                dataType: 'json',
                success: function(stuff) { 
                    //window.location.href = '/cart';
                    console.log("Cart updated !");
                    return false;
                }
            };

            $.ajax(params);
        });
        */
        var variantID = getVariantID();
        var locationStockAvailable = getVariantLocationDetails(variantID);



        // Selectionne le noeud dont les mutations seront observées
        var targetNode = document.querySelector('.infos_dispo_boutique');

        // Options de l'observateur (quelles sont les mutations à observer)
        var config = { childList: true };

        // Fonction callback à éxécuter quand une mutation est observée
        var callback = function(mutationsList) {
          for(var mutation of mutationsList) {
            if (mutation.type == 'childList' && mutation.addedNodes[0].className == "store-availability-container") {

              setupVariantLocationDetails(locationStockAvailable);

              // L'observation peut être arrêtée par la suite
              observer.disconnect();
            } 
          }
        };

        // Créé une instance de l'observateur lié à la fonction de callback
        var observer = new MutationObserver(callback);

        // Commence à observer le noeud cible pour les mutations précédemment configurées
        observer.observe(targetNode, config);





        if(document.querySelector("#tomit_inventory_list") !== null){
          document.querySelector("#tomit_inventory_list").style.menu = "none";
        }
    }
    
    if($('.cart__item-properties').length) {
      $(".cart__item-properties").each(function(){
        var txt = $(this).text();
        if(txt.lastIndexOf("semaine") !== -1 || txt.lastIndexOf("week")) {
          if(getShopLang() == "fr") {
            $('.display-fr').show();
          } else {
            $('.display-en').show();
          }
        }
      });
    }

    //Handle share WishList URL
    var myId = "zooomycopytxtarea";
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if(mutation.addedNodes[0] && mutation.addedNodes[0].id == myId){
            console.log(mutation.addedNodes[0].id);
            replaceWishlistUrl();
          }
        });
    });
    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});


});

// Set the rotation mechanic for the collection carousel in the index page
function rotateSlides(direction){
    //Get the width of an element
    var $firstSlide = $('.collection-custom-slider').find('.linkspan:first');
    var activeSlide = $('.collection-custom-slider .linkspan a.active');
    var slideWidth = direction == "prev" ? -1 * $firstSlide.width() : $('.collection-custom-slider .linkspan.active').width();
    if(window.screen.width > 500 && direction != "prev") {
        slideWidth = 2*slideWidth;
    }

    //Move the element so the next one take his place
    $firstSlide.animate({marginLeft: -slideWidth}, 1000, function(){

        //Move the slide
        var $lastSlide = $('.collection-custom-slider').find('.linkspan:last');
        if (direction == "prev") {
            $firstSlide.after($lastSlide);
            $firstSlide.css({marginLeft: 0});
        } else {
            $lastSlide.after($firstSlide);
            $firstSlide.css({marginLeft: 0});
        }

        //Activate the background of the section based on the current middle element
        var middle = Math.ceil(($('.collection-custom-slider .linkspan').length/2));
        var $midElement = $('.collection-custom-slider .linkspan:nth-child('+middle+')');
        $('.collection-custom-slider .linkspan a.active').removeClass('active');
        $('.collection-custom-slider .linkspan.active').removeClass('active');
        $midElement.addClass("active");
        $midElement.children('a').addClass("active");
        if($midElement.children('a').data('image') != "empty" && $midElement.children('a').data('image').includes("no-image") == false) {
            $('.collection-custom-slider').css("background-image", 'url('+ $midElement.children('a').data('image') +')');
        } else {
            $('.collection-custom-slider').css("background-color", '#a4a4a4');
            $('.collection-custom-slider').css("background-image", 'unset');
        }
        var middleUrl = $midElement.children('a').attr('href');
        $('#collection_btn').attr('href', middleUrl);
    });
}

//Return "available", "delayed" or "unavailable" in function of the variant passed in parameters (special handling if the variant is a size)
function getAvailability(variantValue, isSizeRelated = false, isQtyRelated = false){
    if(isQtyRelated) {
        var dataDispo = $('#variant-selector option:first').data("variant-quantity");
        if((variantValue == "Paire" && dataDispo < 2) || (variantValue != "Paire" && dataDispo < 1)){
            return "unavailable";
        } else {
            return "available";
        }
    } else {
        var dataDispo = $('#variant-selector option[data-variant="'+variantValue+'"]').data("variant-quantity");
        if( dataDispo > 0 ){
            return "available";
        } else if(isSizeRelated) {
            //If product is not available, we're searching for taller product to resize at the customer size
            var smallerSize = $('#variant-selector option[data-variant="'+variantValue+'"]').next(),
                smallerSize1 = smallerSize.data("variant-quantity"),
                smallerSize2 = smallerSize.next().data("variant-quantity"),
                biggerSize = $('#variant-selector option[data-variant="'+variantValue+'"]').prev(),
                biggerSize1 = biggerSize.data("variant-quantity"),
                biggerSize2 = biggerSize.prev().data("variant-quantity");

            if( smallerSize1 > 0 || smallerSize2 > 0 || biggerSize1 > 0 || biggerSize2 > 0 ) {
                return "delayed";
            } else {
                return "unavailable";
            }
        } else {
            return "unavailable";
        }
    }
}

//Update the template in function of the availability of the variant
function updateProductFormVariant(dataAvailability, isTextButtonNeeded = false) {

    //Hide the add to cart button text while processing
    if(isTextButtonNeeded){
        $('.base-add-to-cart-text').hide();
        $('.updated-add-to-cart-text').hide();
    }

    if( dataAvailability == "available" ){
        // it's available now
        $('.product-delivery-available').show();
        $('.product-delivery-unavailable').hide();
        $('.product-delivery-available-with-delay').hide();
        $('.infos_dispo_boutique').show();

        //Update delay data on the shopping_cart
        $('#custom_variant_delay').val($('.product-delivery-available').text());

        //Update cart button text
        if(isTextButtonNeeded) {
            $('.updated-add-to-cart-text-available').show();
            $('.recap_add_to_cart_button button span').text($('.updated-add-to-cart-text-available').text());
        }
    } else if(dataAvailability == "delayed"){
        // it's available with delay
        $('.product-delivery-available').hide();
        $('.product-delivery-unavailable').hide();
        $('.product-delivery-available-with-delay').show();
        $('.infos_dispo_boutique').hide();
        
        //Update delay data on the shopping_cart
        $('#custom_variant_delay').val($('.product-delivery-available-with-delay').text());

        //Update cart button text
        if(isTextButtonNeeded) {
            $('.updated-add-to-cart-text-available').show();
            $('.recap_add_to_cart_button button span').text($('.updated-add-to-cart-text-available').text());
        }
    } else {
        // it's unavailable
        $('.product-delivery-available').hide();
        $('.product-delivery-unavailable').show();
        $('.product-delivery-available-with-delay').hide();
        $('.infos_dispo_boutique').hide();
        
        //Update delay data on the shopping_cart
        $('#custom_variant_delay').val($('.product-delivery-unavailable').text());

        //Update cart button text
        if(isTextButtonNeeded) {
            $('.updated-add-to-cart-text-on-order').show();
            $('.recap_add_to_cart_button button span').text($('.updated-add-to-cart-text-on-order').text());
        }
    }
}

//Update the recap of the order
function updateTextRecap(variantValue, isSizeRelated = false, isQtyRelated = false) {
    var lang = getShopLang();
    var tagEshopPrefix = ""; 
    if($('.product__vendor').length) {
        tagEshopPrefix = $('.product__vendor').contents().filter(function(){ 
          return this.nodeType == 3; 
        })[0].nodeValue;
    }
    var tagCollectionPrefix = $('h1.product-single__title').text();
    var colorPrefix = (lang == "fr") ? "Or" : "Gold";
    if(isSizeRelated) {
        var optionPrefix = (lang == "fr") ? " - Taille" : " - Size";
    } else if(isQtyRelated) {
        var optionPrefix = "";
        var newPrice = (variantValue == "Paire") ? $(".product_pair_price:first").text() : $(".product_unit_price:first").text();
        variantValue = "";
        $('.recap_add_to_cart_infos_price_control').text(newPrice);
    } else if(variantValue == "no variant"){
        variantValue = "";
        var optionPrefix = "";
    } else{
        // ##### CASE CHAINE ici ####
        var newPrice = $('#variant-selector option[data-variant="'+variantValue+'"]').data("price");
        $(".product_unit_price:first").text(newPrice);
        variantValue = "";
        var optionPrefix = "";
    }

    $('.recap_add_to_cart_infos_eshop').text(tagEshopPrefix);
    $('.recap_add_to_cart_infos_collection').text(tagCollectionPrefix);
    $('.lang_infos_color').text(colorPrefix);
    $('.recap_add_to_cart_infos_variant').text(optionPrefix+' ' + variantValue);
}

//Process the Qty add to cart if variant is a "Paire"
function processQty(variantValue) {
    if(variantValue == "Paire") {
        $('#variant-selector').val($('#variant-selector option:first').val());
        $('#Option1').val($('#Option1 option:first').val());
        $('#Quantity-product--static').val(2);
        $('.product_unit_price').hide();
        $('.product_pair_price').show();
    } else {
        $('#Quantity-product--static').val(1);
        $('.product_pair_price').hide();
        $('.product_unit_price').show();
    }
}

//Return "fr" or "en" in function of the shop current language
function getShopLang() {
    return lang = window.location.href.indexOf('/en/') != -1 ? "en" : "fr";
}

//calcul ration from value 1 by value 2
function getRatio(val1, val2){
    return Math.ceil(val1/val2);
}

function replaceWishlistUrl() {
  //Cache les boutons de partage lorsque l'on reçoit une wishlist
  if(window.location.href.indexOf("share") !== -1) {
    $('#zooomyemailfbtn').hide();
  }
  var url = $('#zooomycopytxtarea').text();
  var newUrl = url.replace(/\.myshopify/, "");
  $('#zooomycopytxtarea').text(newUrl);
}

//return the current selected variant ID
function getVariantID() {
  var option1 = document.querySelector('#Option1') !== null ? document.querySelector('#Option1') : false;
  if (option1 != false && typeof option1.value != 'undefined') {
    var variantID = document.querySelector('#variant-selector option[data-variant="'+option1.value+'"]').value;
  } else {
    var variantID = document.querySelector('#variant-selector').value;                 
  }
  return variantID;
}


//return an array with all the available location name for a given variant ID
function getVariantLocationDetails(variantID) {
  var locationStockAvailable = [];
  let appUrl = "/apps/get-stock";
  let dataUrl = {
    variant_id: variantID,
    shop_name: "stoneparis.myshopify.com"
  }

  function setupVariantStock(response) {
    locationStockAvailable = response.stock;
  }

  let param = {
    url: appUrl,// mandatory
    data: dataUrl,
    success: setupVariantStock,
    async:false // to make it synchronous
  }

  $.get(param);

  return locationStockAvailable;
}


//62789615774 = Mont Thabor
//65835303165 = Saint Père 
//set up the location detailed message below add to cart button
function setupVariantLocationDetails(locationStockAvailable) {
  //console.log(locationStockAvailable);

  if(locationStockAvailable["62789615774"] && locationStockAvailable["65835303165"]) {
      $("#available_just_one").hide();
      $("#available_both").show();
  } else if (locationStockAvailable){
    var locationName = locationStockAvailable["62789615774"] ? "au 28 rue du Mont Thabor" : "au 60 rue des Saints Pères";
    $("#available_just_one .location_address").text(locationName);
    $("#available_just_one").show();
    $("#available_both").hide();
  } else {
    $("#available_just_one").hide();
    $("#available_both").hide();
  }
}